import tw from 'tailwind-styled-components';
import { Facebook, Linkedin, Twitter, Telegram, Angellist, Github, Medium } from 'styled-icons/fa-brands';

const Container = tw.ul`
  flex
  items-center
  list-none
  p-0
  justify-center
  gap-4

  md:justify-start
`;

const Link = tw.a`
  text-typography-subtle/50
`;

const SocialMediaProfiles = ({ facebook, linkedin, twitter, telegram, angelList, github, medium, className }) => (
  <Container className={className}>
    {!!facebook && <li><Link href={facebook} rel="noopener" name="Bidali on Facebook"><Facebook className="w-6 h-6" /></Link></li>}
    {!!linkedin && <li><Link href={linkedin} rel="noopener" name="Bidali on LinkedIn"><Linkedin className="w-6 h-6" /></Link></li>}
    {!!twitter && <li><Link href={twitter} rel="noopener" name="Bidali on Twitter"><Twitter className="w-6 h-6" /></Link></li>}
    {!!telegram && <li><Link href={telegram} rel="noopener" name="Bidali on Telegram"><Telegram className="w-6 h-6" /></Link></li>}
    {!!angelList && <li><Link href={angelList} rel="noopener" name="Bidali on AngelList"><Angellist className="w-6 h-6" /></Link></li>}
    {!!github && <li><Link href={github} rel="noopener" name="Bidali on Github"><Github className="w-6 h-6" /></Link></li>}
    {!!medium && <li><Link href={medium} rel="noopener" name="Bidali on Medium"><Medium className="w-6 h-6" /></Link></li>}
  </Container>
);

export default SocialMediaProfiles;
